<template>
	<div class="offDetail">
		<!-- 顶部导航 -->
		<div class="nav" style="border: none;">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>订单详情</span>
			<div></div>
		</div>
		<!-- 头部背景块 -->
		<div class="bgd"></div>
		<div class="main">
			<!-- 订单编号 -->
			<div class="main-top">
				<img src="../../../assets/offDetail.png" alt="">
				<div class="list-main">
					<div>
						<div>供货方式：{{list.supplies_mode}}</div>
					</div>
					<div class="list-bottom">
						<div>订单方式：{{list.order_mode}}</div>
						<div>{{list.create_time}}</div>
					</div>
				</div>
			</div>
			<!-- 订单详情 -->
			<div class="main-container">
				<van-panel>
					<div slot="header" class="container-header">
						<img src="../../../assets/offdetail.jpg" alt="">
						<div>订单来源：{{list.source}}</div>
						<div style="word-break:break-word">订单编号：{{list.order_number}}</div>
						<div>付款码：{{list.payment_user}}</div>
					</div>
					<div class="container-default">
						<div class="default-top">
							<div>单据图片:</div>
							<img v-for="(item,index) in list.image" :key="index" :src="item | handleUrl" alt="" v-if="list.image != undefined">
							<div>合同图片:</div>
							<img v-for="(item,index) in list.contract_image" :key="index" :src="item | handleUrl" alt="" v-if="list.image != undefined">
							<div>图纸图片:</div>
							<img v-for="(item,index) in list.draw_image" :key="index" :src="item | handleUrl" alt="" v-if="list.image != undefined">
							<div>
								<label for="">备注：</label><span>{{list.order_message}}</span>
							</div>
						</div>
						<div class="default-foot">
							<div>
								<label for="">联系人：</label><span>{{list.real_name}}</span>
							</div>
							<div>
								<label for="">联系电话：</label><span>{{list.phone}}</span>
							</div>
							<div>
								<label for="">收货地址：</label><span>{{list.address}}</span>
							</div>
							<div style="height: 1rem; margin-top: 0.5rem; border-top: 1px solid #ededed; padding-top: 0.5rem;">支付金额：<span
								 class="f1452f">¥{{list.total}}</span></div>
							<div v-if="list.payment_image==null && list.gateway==1">
								<div style="margin-bottom: 0.1875rem; margin-top: 14px;">上传支付凭证：</div>
								<van-uploader :after-read="subCamera" v-model="fileLists" :max-count="1" />
							</div>
							<div v-else-if="list.gateway==1">
								<div style="margin-bottom: 0.1875rem; margin-top: 14px;">支付凭证：</div>
								<img :src="list.payment_image | handleUrl" />
							</div>
						</div>
					</div>
				</van-panel>
			</div>
			<!-- 底部提示 -->
			<div class="tips">
				如有疑问请拨打：400-8722-000
			</div>
			<div style="width: 100%; height: 3rem;">
			</div>
		</div>
		<van-goods-action style="display: flex; justify-content: space-between;">
			<div style="width: 36%; display: flex;justify-content: space-around;">
				<van-goods-action-icon icon="wap-home-o" text="首页" to="/home" />
				<van-goods-action-icon v-if="list.state == 0" icon="close" text="取消订单" @click="dellist" />
				<van-goods-action-icon icon="phone-o" text="客服" @click="open53" />
			</div>
			<van-goods-action-button v-if="list.gateway==1 && list.payment_image==null && list.state == 0" type="warning" text="上传凭证"
			 @click="getvouchers" />
			<van-goods-action-button v-if="list.gateway==1 && list.payment_image!=null && list.state == 0" type="warning" text="审核中" />
			<van-goods-action-button v-if="list.gateway==0 && list.state == 0" type="danger" text="立即支付" @click="show=true" />
			<van-button block plain round v-if="list.gateway==0 && list.state != 0" type="danger" size="small" style="width: 33%; margin-right: 0.8rem;"
			 :text="list.state_text[list.state]" />
		</van-goods-action>
		<!-- 选择支付方式 -->
		<van-popup v-model="show" position="bottom">
			<van-panel class="payment">
				<div slot="header" class="payment_header">
					支付方式
				</div>
				<div class="payment_content">
					<van-radio-group v-model="radio">
						<van-cell-group>
							<van-cell title="微信支付" clickable @click="radio='1'">
								<div slot="icon" class="payment_icon">
									<img src="../../../assets/wx.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="1" />
							</van-cell>
							<van-cell title="支付宝支付" clickable @click="radio='2'">
								<div slot="icon" class="payment_icon">
									<img src="../../../assets/zfb.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="2" />
							</van-cell>
							<!--<van-cell title="银行卡支付" clickable @click="radio='3'">
								<div slot="icon" class="payment_icon">
									<img src="../../../assets/yl.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" disabled slot="right-icon" name="3" />
							</van-cell> -->
						</van-cell-group>
					</van-radio-group>
					<div class="pays_btn">
						<button @click="nextPay">确定</button>
					</div>
				</div>
			</van-panel>
		</van-popup>
	</div>
</template>

<script>
	export default {
		name: "OffDetail",
		data() {
			return {
				list: [],
				show: false,
				radio: '1',
				annex: [], //附件列表,
				fileLists: []
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/Offline_Order/offlineOrderInfo', {
				order_number: this.$route.query.id
			}).then((res) => {
				if (res.data.code == 2) {
					this.list = res.data.data;
				}
			}).catch(function(err) {
				console.log(err);
			});
		},
		methods: {
			//继续支付
			nextPay() {
				if (this.radio == '1') {
					window.location.href = baseUrl + '/mobile/Pay/offlineWapWxPay?out_trade_no=' + this.list.order_number
				} else if (this.radio == '2') {
					window.location.href = baseUrl + '/mobile/Pay/offlineWapPay?out_trade_no=' + this.list.order_number
				} else {
					this.$toast('暂不支持');
				}
			},
			//上传附件
			subCamera(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annex.push(res.data.data);
					}
				}).catch(function(err) {
					console.log(err);
				})
			},
			dellist() {
				var t = this
				this.$dialog.confirm({
					title: '订单取消后将导致您的订单消失',
					message: '您确定要取消订单吗？'
				}).then(() => {
					this.$axios.post(baseUrl + '/mobile/Offline_Order/offlineOrderDel', {
						id: this.list.id,
					}).then(res => {
						t.$toast("订单取消成功");
						t.back();
					}).catch((err) => {
						console.log(err);
					})
				}).catch(() => {});
			},
			// 提交凭证图片
			getvouchers() {
				var that = this;
				if (that.annex.length == 0) {
					that.$toast('请上传凭证');
					return
				};
				that.$axios.post(baseUrl + '/mobile/Offline_Order/payment', {
					order_number: that.list.order_number,
					payment_image: that.annex[0],
				}).then(res => {
					that.$toast("提交成功");
					location.reload()
				}).catch((err) => {
					console.log(err);
				})
			},
		},
		filters: {
			'handleType': function(val) {
				switch (val) {
					case 1:
						return val = '俱百家直供';
						break;
					case 2:
						return val = '体验店供货';
						break;
					case 3:
						return val = '其他供货';
						break;
				}
			}
		},
	}
</script>

<style scoped>
	@import 'offDetail.css';
</style>



// WEBPACK FOOTER //
// src/components/min/offlineList/offDetail.vue